// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { CustomerRegistrationResponseFragmentDoc } from '../../../auth/fragments/customerRegistrationResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../../../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../../../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../../fragments/costumerConsultant.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartJewelleryNewCustomerDocument = `
    mutation addToCartJewelleryNewCustomer($input: DesignStudioJewelleryInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  createDesignStudioProductAndAddToCartJewelleryNewCustomer(
    input: $input
    customer: $customer
  ) {
    __typename
    ... on CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer {
      customer {
        ...customerRegistrationResponse
      }
    }
  }
}
    ${CustomerRegistrationResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}`;

export function useAddToCartJewelleryNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartJewelleryNewCustomerMutation, SchemaTypes.AddToCartJewelleryNewCustomerMutationVariables>(AddToCartJewelleryNewCustomerDocument);
};